import { Link } from "react-router-dom";
import { Heart, MessageCircle, Trash2 } from "lucide-react";
import { useWishlist } from "@/lib/wishlist";
import { waLink } from "@/lib/api";

export default function SavedWishlist() {
  const { list, remove, clear } = useWishlist();
  if (!list.length) {
    return (
      <div className="bg-white border border-ink/10 rounded-3xl p-10 text-center" data-testid="wishlist-empty">
        <Heart className="mx-auto text-terra" size={28} />
        <p className="font-serif text-2xl font-bold mt-3">Nothing saved yet</p>
        <p className="mt-2 text-sm text-ink/60">Tap the heart on any tour or place — it's saved to your Google account and follows you across devices.</p>
      </div>
    );
  }
  const msg = `Hi Random Rider! I'd love a plan covering: ${list.map((i) => i.name).join(", ")}.`;
  return (
    <div data-testid="wishlist-saved">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <p className="text-sm text-ink/60">{list.length} saved · synced to your account</p>
        <div className="flex gap-2">
          <a href={waLink(msg)} target="_blank" rel="noreferrer" data-testid="wishlist-send-whatsapp" className="inline-flex items-center gap-1.5 bg-[#25D366] text-white text-xs font-semibold px-4 py-2 rounded-full hover:brightness-110"><MessageCircle size={13} /> Plan these with us</a>
          <button onClick={clear} data-testid="wishlist-clear" className="text-xs font-semibold text-ink/50 hover:text-red-600 px-3">Clear</button>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((it) => (
          <div key={it.id} className="group bg-white border border-ink/10 rounded-3xl overflow-hidden" data-testid={`wishlist-item-${it.id.slice(0, 8)}`}>
            <Link to={it.type === "tour" ? `/tours/${it.slug}` : `/places/${it.slug}`} className="block aspect-[4/3] overflow-hidden">
              <img src={it.image} alt={it.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
            </Link>
            <div className="p-4 flex items-start justify-between gap-3">
              <div>
                <p className="font-mono text-[10px] uppercase tracking-widest text-terra">{it.type}</p>
                <Link to={it.type === "tour" ? `/tours/${it.slug}` : `/places/${it.slug}`} className="font-semibold text-ink hover:text-terra leading-snug">{it.name}</Link>
                {it.meta && <p className="text-xs text-ink/50 mt-0.5">{it.meta}</p>}
              </div>
              <button onClick={() => remove(it.id)} aria-label="Remove" data-testid={`wishlist-remove-${it.id.slice(0, 8)}`} className="p-2 rounded-full text-ink/40 hover:bg-red-50 hover:text-red-600 transition-colors"><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
